import Constants from '../Constants.js';
import RoleReducer from './RoleReducer.js';
const {
  getStatus,
  getError,
  getRoles
} = RoleReducer;
class Roles {
  constructor(projectId) {
    this.projectId = projectId;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      const projectId = this.projectId || opts && opts.api && opts.api.projectId;
      dispatch({
        type: Constants.ROLE_STATUS,
        status,
        projectId
      });
      return func(dispatch, getState, opts, projectId).catch(error => {
        dispatch({
          type: Constants.ROLE_STATUS,
          projectId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  list(opts = {}) {
    return this.createAction('list', 'loading', async (dispatch, getState, {
      api
    }, projectId) => {
      const r = await api.project(projectId).roles().list({
        includePermissions: true,
        ...opts
      });
      // assuming all
      dispatch({
        type: Constants.ROLE_LIST,
        projectId,
        items: r.items
      });
      return r;
    });
  }
  create(role, opts) {
    return this.createAction('create', 'creating', async (dispatch, getState, {
      api
    }, projectId) => {
      const r = await api.project(projectId).roles().create(role, {
        includePermissions: true
      });
      // assuming all
      dispatch({
        type: Constants.ROLE_ADD,
        projectId,
        role: r
      });
      return r;
    });
  }

  // get( type, opts ) {
  //   return Util.createAction( {
  //     projectId : this.projectId,
  //     method : 'get',
  //     status : 'loading',
  //     enumType : type,     
  //     opts,    
  //     successActionType : Constants.ENUM_UPDATE
  //   } )
  // }

  // update( type, opts ) {
  //   return Util.createAction( {
  //     projectId : this.projectId,
  //     method : 'update',
  //     status : 'updating',
  //     enumType : type,     
  //     opts,    
  //     successActionType : Constants.ENUM_UPDATE
  //   } )
  // }

  // delete( type, opts ) {
  //   return Util.createAction( {
  //     projectId : this.projectId,
  //     method : 'delete',
  //     status : 'deleting',
  //     enumType : type,   
  //     opts,
  //     successActionType : Constants.ENUM_REMOVE
  //   } )
  // }

  // State accessors 
  getStatus(state) {
    return getStatus(state, this.projectId);
  }
  getError(state) {
    return getError(state, this.projectId);
  }
  getRoles(state) {
    return getRoles(state, this.projectId);
  }
}
export default Roles;